var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.08579 24.9172C6.89689 23.0063 8.79063 21.666 10.9974 21.666H18.9974C21.2042 21.666 23.0979 23.0063 23.909 24.9172M20.3307 11.666C20.3307 14.6115 17.9429 16.9993 14.9974 16.9993C12.0519 16.9993 9.66406 14.6115 9.66406 11.666C9.66406 8.7205 12.0519 6.33268 14.9974 6.33268C17.9429 6.33268 20.3307 8.7205 20.3307 11.666ZM28.3307 14.9993C28.3307 22.3631 22.3612 28.3327 14.9974 28.3327C7.6336 28.3327 1.66406 22.3631 1.66406 14.9993C1.66406 7.63555 7.6336 1.66602 14.9974 1.66602C22.3612 1.66602 28.3307 7.63555 28.3307 14.9993Z",
    stroke: "#38CB89",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileGreen);
export default __webpack_public_path__ + "static/media/profile-green.e8fdc479c112211d350c38b37d9a33f3.svg";
export { ForwardRef as ReactComponent };